import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import moment from "moment";
import {
  ValidCaptcha,
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
  validaNumeroTelefono,
  validaEmail,
  validaDecimal,
  formatoDeci,
} from "../../util/varios";
import axios from "axios";
import CatalogoResponExpendio from "../../catalogos/catalogoRspnExp";
import TablaClaseMinas from "./tablaClassR";
import TablaDeudaMinas from "./tablaDeudaMinas";
import TablaHistoricoMinas from "./historicoDeudaMinas";
import { ClaveSupervisor } from "../configuracionGeneral/modalClaveSupervisor";

export const ExpMinas = (props) => {
  const exonmina = JSON.parse(localStorage.getItem("exonmina"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const cmbMesDecla = useRef();
  const cmbAnioDecla = useRef();

  const [mostrar, setMostrar] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [activate, setActivate] = useState(false);
  let fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  let anioActu = JSON.parse(localStorage.getItem("anioactu"));
  const [body, setBody] = useState(null);
  const txtCedula = useRef();
  const txtNombreRespon = useRef();
  const txtObserStatus = useRef();
  const txtDireccionRespon = useRef();
  const txtMonto = useRef();
  const txtCedulaPro = useRef();
  const txtNombrePro = useRef();
  const txtNumPro = useRef();
  const txtDireccionPro = useRef();
  const txtSucursal = useRef();
  const txtId = useRef();
  const chkIn = useRef();
  const txtDeclara = useRef();
  const chkIn1 = useRef();
  const chkIn2 = useRef();
  const txtLicencia = useRef();
  const txtResolucion = useRef();
  const txtTipoNac = useRef();
  const txtFechaIns = useRef();
  const chkConvenio = useRef();
  const [fechas, setFechas] = useState(0.0);
  const [tabPago, setTabPago] = useState([]);
  const [tabDeuda, setTabDeuda] = useState([]);
  const [totDeuda, setTotDeuda] = useState("0,00");
  const [tabActividades, setTabActividades] = useState([]);
  const [values, setValues] = useState({
    idagente: "",
    nombre: "",
    direccion: "",
    rif: "",
    nrolicencia: "",
    nroresolucion: "",
    reprelegal: "",
    telefono: "",
    fechainscripcion: "",
    status: "",
    idtipoagente: "",
    observacionstatus: null,
    credito: 0.0,
    email: "",
    exonintereses: false,
    exonmultas: false,
    exonrecargos: false,
    ciudad: "",
    municipio: "",
    statusmina: "",
    conveniomina: false,
  });

  const [editarRif, setEditarRif] = useState(true);
  /*     const [false, setDeshabilitado] = useState(false);
    const [habilitadoNR, setHabilitadoNR] = useState(false);
    const [habilitadoNC, setHabilitadoNC] = useState("disabled"); */
  const [mostrar2, setMostrar2] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [nacnalidad, setNacnalidad] = useState("");
  const [visibleF, setVisibleF] = useState("hidden");
  const cmbSex = useRef();
  const [catalogo, setCatalogo] = useState(false);
  const txtApeRespon = useRef();
  const txtEmail = useRef();
  const txtEmailr = useRef();
  const txtFechNac = useRef();
  const txtStatus = useRef();
  const cmbNacionalidad = useRef();
  const txtTlf1 = useRef();
  const txtTlf2 = useRef();
  const [tecla, setTecla] = useState();
  const [teclas, setTeclas] = useState();
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacionPer, setOperacionPer] = useState(0);
  const txtCiudad = useRef();
  const txtMunicipio = useRef();
  const [municipios, setMunicipios] = useState();
  const [ciudades, setCiudades] = useState();
  const [anios, setAnios] = useState([]);

  const token = JSON.parse(localStorage.getItem("jwtToken"));
  let op = require("../../../public/modulos/datos");

  const onChange = (event) => {
    if (
      event.target.name === "observacionstatusmina" ||
      event.target.name === "direccion" ||
      event.target.name === "nombre" ||
      event.target.name === "nombres" ||
      event.target.name === "apellidosp" ||
      event.target.name === "direccionrespo" ||
      event.target.name === "correoe" ||
      event.target.name === "nrolicenciamina" ||
      event.target.name === "nroresolucionmina"
    ) {
      event.target.value = event.target.value.toUpperCase();
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "municipio") {
      selectCiudad(event.target.value);
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "statusmina") {
      setValues({ ...values, [event.target.name]: event.target.value });
      if (event.target.value === "52") {
        setVisibleF("visible");
      } else if (event.target.value === "51") {
        setVisibleF("hidden");
        txtObserStatus.current.value = "";
      }
    } else if (event.target.name === "nac") {
      let nac = txtTipoNac.current.value;
      //  txtCedulaPro.current.value = "";
      txtCedulaPro.current.focus();
      setNacnalidad(nac);
    } else if (event.target.name === "rif") {
      validaSoloNumero(event);
    } else if (event.target.name === "exoninteresesmina") {
      if (exonmina.substring(0, 1) === "1") {
        setValues({ ...values, [event.target.name]: event.target.checked });
      } else {
        event.target.checked = !event.target.checked;
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "No Tiene Permiso Para Exonerar Intereses",
          icono: "informacion",
        });
      }
    } else if (event.target.name === "exonmultasmina") {
      if (exonmina.substring(1, 2) === "1") {
        setValues({ ...values, [event.target.name]: event.target.checked });
      } else {
        event.target.checked = !event.target.checked;
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "No Tiene Permiso Para Exonerar Multas",
          icono: "informacion",
        });
      }
    } else if (event.target.name === "exonrecargosmina") {
      if (exonmina.substring(2, 3) === "1") {
        setValues({ ...values, [event.target.name]: event.target.checked });
      } else {
        event.target.checked = !event.target.checked;
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "No Tiene Permiso Para Exonerar Recargos",
          icono: "informacion",
        });
      }
    } else if (event.target.name === "conveniomina") {
      setValues({ ...values, [event.target.name]: event.target.checked });
    } else {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  };

  const onFecha = () => {
    let tfechas;
    let fecha = parseInt(fechaSistema.substring(1, 5));
    let mes = parseInt(fechaSistema.substring(6, 8));
    let dia = parseInt(fechaSistema.substring(9, 11));
    tfechas = fecha - 18;
    setFechas(tfechas + "-" + 0 + mes + "-" + dia);
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    var valido;
    if (event.which === 13 || typeof event.which === "undefined") {
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtStatus.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar un Estatus",
        icono: "informacion",
      });
      sigue = false;
      txtStatus.current.focus();
    } else if (txtTipoNac.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el Tipo de Nacionalidad",
        icono: "informacion",
      });
      txtTipoNac.current.focus();
      sigue = false;
    } else if (txtCedulaPro.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Por Favor Introdusca la Cedula o Rif del Contribuyente/Empresa",
        icono: "informacion",
      });
      sigue = false;
      txtCedulaPro.current.focus();
    } else if (txtNombrePro.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa el Nombre del Contribuyente u Empresa",
        icono: "informacion",
      });
      sigue = false;
      txtNombrePro.current.focus();
    } else if (txtDireccionPro.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Dirección del Contribuyente/Empresa",
        icono: "informacion",
      });
      sigue = false;
      txtDireccionPro.current.focus();
    } else if (txtNumPro.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el contacto del Contribuyente/Empresa",
        icono: "informacion",
      });
      sigue = false;
      txtNumPro.current.focus();
    } else if (txtEmail.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el Correo del Contribuyente/Empresa",
        icono: "informacion",
      });
      sigue = false;
      txtEmail.current.focus();
    } else if (!validaEmail(txtEmail.current.value.trim())) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Formato del E-Mail no es Valido",
        icono: "informacion",
      });

      txtEmail.current.focus();
    } else if (
      operacionPer === 1 &&
      cmbNacionalidad.current.value.trim() === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Por favor Seleccione la Nacionalidad",
        icono: "informacion",
      });
      sigue = false;
      cmbNacionalidad.current.focus();
    } else if (operacionPer === 1 && cmbSex.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Por favor Seleccione el Sexo del Representante Legal",
        icono: "informacion",
      });
      sigue = false;
      cmbSex.current.focus();
    } else if (operacionPer === 1 && txtCedula.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Por favor Seleccione el Representante Legal",
        icono: "informacion",
      });
      sigue = false;
      txtCedula.current.focus();
    } else if (
      operacionPer === 1 &&
      txtNombreRespon.current.value.trim() === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Nombre del Representante Legal no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtNombreRespon.current.focus();
    } else if (operacionPer === 1 && txtApeRespon.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Apellido del Representante Legal no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtApeRespon.current.focus();
    } else if (
      operacionPer === 1 &&
      txtDireccionRespon.current.value.trim() === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Dirección del Representante Legal no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtDireccionRespon.current.focus();
    } else if (operacionPer === 1 && txtEmailr.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El E-mail del Representante Legal no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtEmailr.current.focus();
    } else if (
      operacionPer === 1 &&
      !validaEmail(txtEmailr.current.value.trim())
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Formato del E-Mail no es Valido",
        icono: "informacion",
      });

      txtEmailr.current.focus();
      sigue = false;
    } else if (operacionPer === 1 && txtFechNac.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "La Fecha de Nacimiento del Representante Legal no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtFechNac.current.focus();
    } else if (operacionPer === 1 && txtTlf1.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "Por Favor Introdusca el Número de Contacto del Respresentante Legal",
        icono: "informacion",
      });
      sigue = false;
      txtTlf1.current.focus();
    } else if (operacionPer === 1 && txtTlf2.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto:
          "Por Favor Introdusca el Número de Contacto del Respresentante Legal",
        icono: "informacion",
      });
      sigue = false;
      txtTlf2.current.focus();
    } else if (txtFechaIns.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha de Inscripción no debe ir Vacia",
        icono: "informacion",
      });
      sigue = false;
      txtFechaIns.current.focus();
    } else if (txtLicencia.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el N° de licencia",
        icono: "informacion",
      });
      sigue = false;
      txtLicencia.current.focus();
    } else if (txtResolucion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe ingresar el N° de Resolucion",
        icono: "informacion",
      });
      sigue = false;
      txtResolucion.current.focus();
    } else if (cmbMesDecla.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar el mes de la primera declaracion.",
        icono: "informacion",
      });
      sigue = false;
      cmbMesDecla.current.focus();
    } else if (cmbAnioDecla.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar el año de la primera declaracion.",
        icono: "informacion",
      });
      sigue = false;
      cmbAnioDecla.current.focus();
    } else if (sigue) {
      var agente = [];
      var repre = [];
      var mina;

      if (operacion !== 3) {
        mina = true;
      } else if (operacion === 3) {
        mina = false;
      }

      agente.push({
        idagente: parseInt(txtId.current.value),
        nombre: txtNombrePro.current.value.trim(),
        direccion: txtDireccionPro.current.value.trim(),
        rif: nacnalidad + txtCedulaPro.current.value,
        nrolicenciamina: txtLicencia.current.value.trim(),
        nroresolucionmina: txtResolucion.current.value.trim(),
        reprelegal: txtCedula.current.value.trim(),
        telefono: txtNumPro.current.value.trim(),
        fechainscripcionmina: txtFechaIns.current.value.trim(),
        statusmina: txtStatus.current.value.trim(),
        idtipoagente: 5,
        mina: mina,
        observacionstatusmina: txtObserStatus.current.value.trim(),
        credito: parseFloat(
          txtMonto.current.value.trim().replace(/\./g, "").replace(",", ".")
        ),
        email: txtEmail.current.value,
        exoninteresesmina: chkIn.current.checked ? true : false,
        exonmultasmina: chkIn1.current.checked ? true : false,
        exonrecargosmina: chkIn2.current.checked ? true : false,
        ciudad: txtCiudad.current.value.trim(),
        municipio: txtMunicipio.current.value.trim(),
        declara: txtDeclara.current.checked ? 1 : 0,
        mesprideclamina: parseInt(cmbMesDecla.current.value),
        anioprideclamina: parseInt(cmbAnioDecla.current.value),
        sucursal: txtSucursal.current.value.trim(),
        conveniomina: chkConvenio.current.checked ? true : false,
      });
      repre.push({
        cedula: parseInt(txtCedula.current.value),
        correoe: txtEmailr.current.value,
        tlf1: txtTlf1.current.value,
        tlf2: txtTlf2.current.value,
        apellidos: txtApeRespon.current.value,
        direccion: txtDireccionRespon.current.value,
        fnacimiento: txtFechNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombreRespon.current.value,
        sexo: cmbSex.current.value,
      });
      setBody({
        operacionper: operacionPer,
        agente: agente,
        repre: repre,
        clases: tabActividades,
        operacioncontri: 1,
      });
      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos?.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);

    let endpoint = "";

    if (operacion === 3) {
      endpoint = `${op.conexion}/api/agente/actualizaragente/2`;
    } else {
      endpoint = `${op.conexion}/api/agente/actualizaragente/${parseInt(
        operacion
      )}`;
    }
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            "llave duplicada viola restricción de unicidad «agente_rif_key»"
          ) {
            mensaje = "Ya existe un Registro con este Rif y Sucursal";
          } else if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_email_key"'
          ) {
            mensaje = "Ya existe un Registro con este correo";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const aceptaClaveSupervisor = () => {
    setMostrar2(false);
    setEditarRif(!editarRif);
    setOperacion(2);
  };

  const cancelaClaveSupervisor = () => {
    setMostrar2(false);
  };

  const blanquear = () => {
    setMostrar1(false);
    setActivate(false);
    setEditarRif(true);
    setVisibleF("hidden");
    setTabDeuda([]);
    setTabPago([]);
    setTabActividades([]);
    setTotDeuda("0,00");
    txtCedula.current.value = "";
    txtNombreRespon.current.value = "";
    txtApeRespon.current.value = "";
    txtDireccionRespon.current.value = "";
    txtEmail.current.value = "";
    txtEmailr.current.value = "";
    txtFechNac.current.value = "";
    txtTlf1.current.value = "";
    txtTlf2.current.value = "";
    cmbNacionalidad.current.value = "";
    cmbSex.current.value = "";
    chkIn.current.checked = false;
    chkIn2.current.checked = false;
    chkIn1.current.checked = false;
    chkConvenio.current.checked = false;
    txtSucursal.current.value = 0;
    setValues({
      idagente: "",
      nombre: "",
      direccion: "",
      rif: "",
      nrolicencia: "",
      nroresolucion: "",
      reprelegal: "",
      telefono: "",
      fechainscripcion: "",
      status: "",
      idtipoagente: "",
      observacionstatus: null,
      credito: 0.0,
      email: "",
      exonintereses: false,
      exonmultas: false,
      exonrecargos: false,
      ciudad: "",
      municipio: "",
      statusmina: "",
      conveniomina: false,
    });

    setOperacion(0);
    setMsg("");
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  const handleCatalogo = () => {
    if (!catalogo) {
      setCatalogo(true);
    } else {
      setCatalogo(false);
    }
  };

  const handleAceptaCatalogoPer = (
    ced,
    corr,
    tlf1,
    tlf2,
    ape,
    direc,
    fcn,
    nac,
    nom,
    sex
  ) => {
    setCatalogo(false);
    setHabilitadoNU(false);

    txtCedula.current.value = ced;
    txtNombreRespon.current.value = nom !== null ? nom.trim() : "";
    txtApeRespon.current.value = ape !== null ? ape.trim() : "";
    txtDireccionRespon.current.value = direc !== null ? direc : "";
    txtEmailr.current.value = corr !== null ? corr.trim() : "";
    txtFechNac.current.value =
      fcn !== null ? moment(fcn).format("YYYY-MM-DD") : "";
    txtTlf1.current.value = tlf1 !== null ? tlf1.trim() : "";
    txtTlf2.current.value = tlf2 !== null ? tlf2.trim() : "";
    cmbNacionalidad.current.value = nac !== null ? nac.toString().trim() : "";
    cmbSex.current.value = sex !== null ? sex.toString().trim() : "";
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreRespon.current.value = "";
      }
    }
  };

  const validarPropie = (event) => {
    event.preventDefault();
    setCiudades("");
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTeclas(event.which);
        if (txtTipoNac.current.value !== "") {
          if (txtSucursal.current.value < 0) {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Debe Introducir el Número de Sucursal",
              icono: "informacion",
            });
          } else {
            let sur = txtSucursal.current.value;
            datosPro(nacnalidad + event.target.value, sur);
          }
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Seleccionar el Tipo de Nacionalidad",
            icono: "informacion",
          });
          txtTipoNac.current.focus();
        }
      } else {
        txtNombrePro.current.value = "";
        txtId.current.value = "";
        txtStatus.current.value = "";
        txtCedulaPro.current.value = "";
        txtNombrePro.current.value = "";
        txtDireccionPro.current.value = "";
        txtNumPro.current.value = "";
        txtFechaIns.current.value = "";
        txtMonto.current.value = "";
        txtLicencia.current.value = "";
        txtResolucion.current.value = "";
        txtEmail.current.value = "";
      }
    }
  };

  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setHabilitadoNU(true);
          txtNombreRespon.current.value = "";
          txtApeRespon.current.value = "";
          txtDireccionRespon.current.value = "";
          txtEmailr.current.value = "";
          txtFechNac.current.value = "";
          txtTlf1.current.value = "";
          txtTlf2.current.value = "";
          cmbNacionalidad.current.value = "";
          cmbSex.current.value = "";
          if (response.data !== "") {
            setHabilitadoNU(false);
            setOperacionPer(0);
            txtNombreRespon.current.value = response.data.nombres;
            txtApeRespon.current.value = response.data.apellidos;
            txtDireccionRespon.current.value = response.data.direccion;
            txtEmailr.current.value = response.data.correoe;
            txtTlf1.current.value = response.data.tlf1;
            txtTlf2.current.value = response.data.tlf2;
            txtFechNac.current.value = moment(response.data.fnacimiento).format(
              "YYYY-MM-DD"
            );
            cmbNacionalidad.current.value =
              response.data.nacionalidad.toString();
            cmbSex.current.value = response.data.sexo.toString();
            if (tecla === 13) {
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreRespon.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      });
  };

  const datosPro = (rif, sur) => {
    let endpoint = `${op.conexion}/api/consulta/seleccionarPro?id=${rif}&id2=${sur}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setVisibleF("hidden");

          if (response.data !== "") {
            setOperacion(2);
            if (response.data.municipio !== "") {
              selectCiudad(
                response.data.municipio.trim(),
                response.data.ciudad.trim()
              );
            }
            if (response.data.reprelegal !== "") {
              datosRes(parseInt(response.data.reprelegal));
              txtCedula.current.value = response.data.reprelegal.trim();
            }
            if (parseInt(response.data.statusmina) === 51) {
              setVisibleF("hidden");
            } else if (parseInt(response.data.statusmina) === 52) {
              setVisibleF("visible");
            } else {
              setVisibleF("visible");
            }

            txtId.current.value = response.data.idagente;
            txtStatus.current.value = response.data.statusmina;
            // txtCedulaPro.current.value = response.data.rif;
            txtNombrePro.current.value = response.data.nombre;
            txtDireccionPro.current.value = response.data.direccion;
            txtNumPro.current.value = response.data.telefono;
            txtMonto.current.value = formatMoneda(
              response.data.credito
                .toString()
                .replace(",", "")
                .replace(".", ","),
              ",",
              ".",
              2
            );
            txtLicencia.current.value = response.data.nrolicenciamina;
            txtResolucion.current.value = response.data.nroresolucionmina;
            txtEmail.current.value = response.data.email;
            setValues(response.data);

            if (teclas === 13) {
              btnAcepta.current.focus();
            }
          } else {
            if (editarRif) {
              setOperacion(1);
            }

            if (teclas === 13) {
              setTimeout(() => {
                txtNombrePro.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      });
  };

  const selectMunicipio = () => {
    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idestado";
    let id = "18";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMunicipios(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      });
  };

  const selectCiudad = (idm, idc) => {
    if (idm !== "") {
      let campos = "*";
      let nomtab = "ciudad";
      let nomid = "idmunicipio";

      let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${idm}&nomtab=${nomtab}&nomid=${nomid}`;

      axios
        .get(endpoint, {
          headers: {
            "x-access-token": `${token}`,
          },
        })
        .then(function (response) {
          if (response.status === 200) {
            setCiudades(response.data);
            txtMunicipio.current.value = idm;

            txtCiudad.current.value = idc;
          }
        })
        .catch(function (error) {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: mensaje,
            icono: "error",
          });
        });
    } else [setCiudades("")];
  };

  const selectCiudad2 = (id) => {
    if (id !== "") {
      let campos = "*";
      let nomtab = "ciudad";
      let nomid = "idmunicipio";

      let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

      axios
        .get(endpoint, {
          headers: {
            "x-access-token": `${token}`,
          },
        })
        .then(function (response) {
          if (response.status === 200) {
            setCiudades(response.data);
          }
        })
        .catch(function (error) {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: mensaje,
            icono: "error",
          });
        });
    } else [setCiudades("")];
  };

  const cerrarModal = () => {
    props.onHideRenderizar();
    props.onHideCancela();
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const SelectDeudaAgenMina = (idagente) => {
    let endpoint = `${
      op.conexion
    }/api/minas/deudas?idagente=${idagente}&fecha=${fechaSistema}&tabconf=${"configminas"}&condic=${"tipodeuda=1"}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          var his = [];
          var totdeu = parseFloat(0.0);
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              totdeu =
                totdeu +
                parseFloat(response.data[i].mondeu) +
                parseFloat(response.data[i].intmoradeu) +
                parseFloat(response.data[i].recargodeu) +
                parseFloat(response.data[i].multa);
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                retenciones: response.data[i].retencion,
                credito: response.data[i].acreditacion,
                totalperi: response.data[i].subtotal,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                nummes: response.data[i].nmes,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            }
          }
          setTotDeuda(
            formatMoneda(totdeu.toString().replace(".", ","), ",", ".", 2)
          );
          setTabDeuda(deu);
          setTabPago(his);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarClase = (idagente) => {
    let endpoint = `${op.conexion}/api/minas/claseminasxagente/${idagente}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setTabActividades(response.data);
            SelectDeudaAgenMina(idagente);
          } else {
            setTabActividades([]);
            SelectDeudaAgenMina(idagente);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  function seleccionarCampos(idclass, descrip, codclass, alicuota) {
    let clases = [];
    if (tabActividades.length > 0) {
      for (let i = 0; i < tabActividades.length; i++) {
        if (idclass !== tabActividades[i].idclaseminas) {
          clases.push(tabActividades[i]);
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "No puede Seleccionar la Misma Clase",
            icono: "informacion",
          });
        }
      }
    }
    clases.push({
      idclaseminas: idclass,
      descripcion: descrip,
      codigoclaseminas: codclass,
      alicuota: alicuota,
    });
    setTabActividades(clases);
  }

  function eliminarCampos(idclass) {
    let clases = [];
    if (tabActividades.length > 0) {
      for (let i = 0; i < tabActividades.length; i++) {
        if (idclass !== tabActividades[i].idclaseminas) {
          clases.push(tabActividades[i]);
        }
      }
    }

    setTabActividades(clases);
  }

  const llenarCampos = () => {
    setOperacion(props.operacion);
    if (props.operacion !== 1) {
      setValues(props.expendedor);
      selectCiudad(props.expendedor.municipio, props.expendedor.ciudad);
      seleccionarClase(props.expendedor.idagente);
      setNacnalidad(props.expendedor.rif.substring(0, 1));
      cmbAnioDecla.current.value = props.expendedor.anioprideclamina;
      if (props.expendedor.statusmina === "52") {
        setVisibleF("visible");
      } else {
        setVisibleF("hidden");
      }
    } else {
      setVisibleF("hidden");
      txtCedula.current.value = "";
      txtNombreRespon.current.value = "";
      txtApeRespon.current.value = "";
      txtDireccionRespon.current.value = "";
      txtEmail.current.value = "";
      txtEmailr.current.value = "";
      txtFechNac.current.value = "";
      txtTlf1.current.value = "";
      txtTlf2.current.value = "";
      cmbNacionalidad.current.value = "";
      cmbSex.current.value = "";
      chkIn.current.checked = false;
      chkIn2.current.checked = false;
      chkIn1.current.checked = false;
      chkConvenio.current.checked = false;
      txtFechaIns.current.value = moment(
        JSON.parse(localStorage.getItem("fechasistema"))
      ).format("YYYY-MM-DD");
      setValues({
        idagente: "",
        nombre: "",
        direccion: "",
        rif: "",
        nrolicencia: "",
        nroresolucion: "",
        reprelegal: "",
        telefono: "",
        fechainscripcion: "",
        status: "",
        idtipoagente: "",
        observacionstatus: null,
        credito: 0.0,
        email: "",
        exonintereses: false,
        exonmultas: false,
        exonrecargos: false,
        ciudad: "",
        municipio: "",
        statusmina: "",
        conveniomina: false,
      });
      setCiudades("");
    }
  };

  useEffect(() => {
    selectMunicipio();
    onFecha();
    const element = [];

    for (let i = 2010; i <= anioActu; i++) {
      element.push(i);
    }

    setAnios(element);
  }, []);

  const editar = () => {
    setMostrar2(true);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={llenarCampos}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <Modal.Title style={{ color: "#fff" }}>
          {props.operacion === 1
            ? "Agregar Contribuyente Minas."
            : props.operacion === 2
            ? "Editar Contribuyente Minas."
            : props.operacion === 3
            ? "Eliminar Contribuyente Minas."
            : "Consultar Contribuyente Minas."}
        </Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <ClaveSupervisor
          show={mostrar2}
          onHideCancelaSup={cancelaClaveSupervisor}
          onHideAceptaSup={aceptaClaveSupervisor}
        />

        <CatalogoResponExpendio
          show={catalogo}
          onHideCancelaCatPer={handleCatalogo}
          onHideAceptaCatPer={handleAceptaCatalogoPer}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div>
          <ul className="nav mb-2" id="ex-with-icons" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="nav-link text-dark rounded"
                style={{ backgroundColor: "#25d366" }}
                id="ex-with-icons-tab-1"
                data-mdb-toggle="tab"
                href="#ex-with-icons-tabs-1"
                role="tab"
                aria-controls="ex-with-icons-tabs-1"
                aria-selected="true"
              >
                <i className="fas fa-chart-pie fa-fw me-2" />
                Datos Generales
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link text-dark rounded"
                style={{ backgroundColor: "#55acee" }}
                id="ex-with-icons-tab-2"
                data-mdb-toggle="tab"
                href="#ex-with-icons-tabs-2"
                role="tab"
                aria-controls="ex-with-icons-tabs-2"
                aria-selected="false"
              >
                <i className="fas fa-highlighter fa-fw me-2" />
                Clasificador
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link text-light rounded"
                style={{ backgroundColor: "#F93154" }}
                id="ex-with-icons-tab-3"
                data-mdb-toggle="tab"
                href="#ex-with-icons-tabs-3"
                role="tab"
                aria-controls="ex-with-icons-tabs-3"
                aria-selected="false"
              >
                <i className="fas fa-money-check fa-fw me-2" />
                Deudas
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link text-dark rounded"
                style={{ backgroundColor: "#FFA900" }}
                id="ex-with-icons-tab-4"
                data-mdb-toggle="tab"
                href="#ex-with-icons-tabs-4"
                role="tab"
                aria-controls="ex-with-icons-tabs-4"
                aria-selected="false"
              >
                <i className="fas fa-book-open fa-fw me-2" />
                Historico
              </a>
            </li>
          </ul>
          <div
            className="tab-content"
            id="ex-with-icons-content"
            style={{ fontFamily: "Times New Roman, Times, serif" }}
          >
            <div
              className="tab-pane fade show active"
              id="ex-with-icons-tabs-1"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-1"
            >
              <div className="row rounded mx-auto">
                <div className="input-group py-1 input-group-sm col-sm-2">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Código:
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    disabled={true}
                    name="idagente"
                    ref={txtId}
                    defaultValue={
                      props.expendedor ? props.expendedor.idagente : ""
                    }
                  />
                </div>

                <div className="input-group py-1 input-group-sm col-sm-3">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Fecha de Inscripción:
                  </label>
                  <input
                    type="date"
                    autoComplete="off"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    disabled={operacion === 4 || operacion === 3 ? true : false}
                    max={moment(fechaSistema).format("YYYY-MM-DD")}
                    ref={txtFechaIns}
                    name="fechainscripcionmina"
                    defaultValue={
                      props.expendedor
                        ? props.expendedor.fechainscripcionmina !== null
                          ? moment(
                              props.expendedor.fechainscripcionmina
                            ).format("YYYY-MM-DD")
                          : ""
                        : moment(fechaSistema).format("YYYY-MM-DD")
                    }
                    onChange={onChange}
                    id="inputFechaInscripcion"
                  />
                </div>

                <div className="input-group py-1 input-group-sm col-sm-2">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Estatus:
                  </label>
                  <select
                    disabled={operacion === 4 || operacion === 3 ? true : false}
                    ref={txtStatus}
                    className="form-select text-center"
                    id="inputStatus"
                    name="statusmina"
                    value={values.statusmina}
                    onChange={onChange}
                  >
                    <option value="">seleccione</option>
                    <option value="51">ACTIVO</option>
                    <option value="52">INACTIVO</option>
                  </select>
                </div>

                <div
                  className="input-group py-1 input-group-sm col-sm-5"
                  style={{ visibility: visibleF }}
                >
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Observación Estatus:
                  </label>
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    disabled={operacion === 4 || operacion === 3 ? true : false}
                    name="observacionstatusmina"
                    ref={txtObserStatus}
                    defaultValue={
                      props.expendedor
                        ? props.expendedor.observacionstatusmina
                        : ""
                    }
                    onChange={onChange}
                  />
                </div>

                <div className="container rounded row border mx-auto col-md-12">
                  <div className=" col-md-6 row py-3 px-2">
                    <div className="col-sm-11 py-0 text-success2">
                      <h4 className="text-success2  titulos">
                        <i className="fas fa-lg px-2 fa-user-edit"></i>Datos del
                        Contribuyente Minas
                      </h4>
                      <hr className="py-0" />
                    </div>

                    <div className="input-group py-1 input-group-sm col-sm-8">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Cédula o RIF:
                      </label>
                      <select
                        disabled={
                          (operacion === 4 ||
                            operacion === 3 ||
                            operacion === 2) &&
                          editarRif
                            ? true
                            : false
                        }
                        ref={txtTipoNac}
                        name="nac"
                        onChange={onChange}
                        defaultValue={
                          props.expendedor && props.expendedor.rif
                            ? props.expendedor.rif.substring(0, 1)
                            : ""
                        }
                        className="col-sm-3 px-2 form-select form-control-sm"
                      >
                        <option value="">-</option>
                        <option key="0" value="V">
                          V
                        </option>
                        <option key="1" value="J">
                          J
                        </option>
                        <option key="2" value="G">
                          G
                        </option>
                        <option key="3" value="P">
                          P
                        </option>
                      </select>
                      <input
                        type="text"
                        className="form-control col-5"
                        autoComplete="off"
                        onKeyUp={validarPropie}
                        onBlur={validarPropie}
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        ref={txtCedulaPro}
                        disabled={
                          (operacion === 4 ||
                            operacion === 3 ||
                            operacion === 2) &&
                          editarRif
                            ? true
                            : false
                        }
                        maxLength="9"
                        defaultValue={
                          props.expendedor && props.expendedor.rif
                            ? props.expendedor.rif.substring(1, 10)
                            : ""
                        }
                        onChange={onChange}
                        id="rif"
                        name="rif"
                      />
                      <button
                        className="btn btn-sm col-sm-2  btn-warning "
                        /* disabled={editarRif}  */ onClick={editar}
                      >
                        <i className="fa fa-edit"></i>{" "}
                      </button>
                    </div>

                    <div className="input-group py-1 input-group-sm col-sm-3">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Sucursal:
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        onKeyUp={operacion === 1 ? validarPropie : ""}
                        aria-label="Sizing example input"
                        min={0}
                        autoComplete="off"
                        aria-describedby="inputGroup-sizing-sm"
                        ref={txtSucursal}
                        disabled={
                          (operacion === 4 ||
                            operacion === 3 ||
                            operacion === 2) &&
                          editarRif
                            ? true
                            : false
                        }
                        defaultValue={
                          props.expendedor && props.expendedor.sucursal
                            ? props.expendedor.sucursal
                            : 0
                        }
                        onChange={onChange}
                        id="sucursal"
                        name="sucursal"
                      />
                    </div>

                    <div className="input-group py-1 input-group-sm col-sm-12">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Nombre/Razón Social:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        ref={txtNombrePro}
                        disabled={
                          operacion === 4 || operacion === 3 ? true : false
                        }
                        name="nombre"
                        defaultValue={
                          props.expendedor ? props.expendedor.nombre : ""
                        }
                        onChange={onChange}
                        id="inputPropiet"
                      />
                    </div>

                    <div className="input-group py-1 input-group-sm col-sm-12">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Dirección:
                      </label>
                      <textarea
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        ref={txtDireccionPro}
                        disabled={
                          operacion === 4 || operacion === 3 ? true : false
                        }
                        name="direccion"
                        defaultValue={
                          props.expendedor ? props.expendedor.direccionage : ""
                        }
                        onChange={onChange}
                        id="inputDirecpropiet"
                      />
                    </div>

                    <div className="input-group py-1 input-group-sm col-sm-5">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Teléfono:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        maxLength="12"
                        ref={txtNumPro}
                        disabled={
                          operacion === 4 || operacion === 3 ? true : false
                        }
                        name="telefono"
                        defaultValue={
                          props.expendedor ? props.expendedor.telefono : ""
                        }
                        onChange={handleInputNumChange}
                        id="inputTelefonopropie"
                      />
                    </div>
                    <div className="input-group py-1 input-group-sm col-sm-7">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        E-mail:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control uppercase"
                        disabled={
                          operacion === 4 || operacion === 3 ? true : false
                        }
                        aria-label="Sizing example input"
                        ref={txtEmail}
                        aria-describedby="inputGroup-sizing-sm"
                        defaultValue={
                          props.expendedor
                            ? props.expendedor.email &&
                              props.expendedor.email.trim()
                            : ""
                        }
                        id="inputEmail"
                        name="email"
                      />
                    </div>
                    <div className="input-group py-1 input-group-sm col-sm-6">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Municipio:
                      </label>

                      <select
                        disabled={
                          operacion === 4 || operacion === 3 ? true : false
                        }
                        ref={txtMunicipio}
                        className="form-select form-select-sm"
                        id="inputStatus"
                        name="municipio"
                        onChange={onChange}
                        value={
                          values.municipio !== null
                            ? values.municipio.trim()
                            : ""
                        }
                      >
                        <option value="">Seleccione</option>
                        {municipios &&
                          municipios.map((item, index) => (
                            <option key={index} value={item.idmunicipio}>
                              {" "}
                              {item.nombre}{" "}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="input-group py-1 input-group-sm col-sm-6">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Ciudad:
                      </label>
                      <select
                        disabled={
                          operacion === 4 || operacion === 3 ? true : false
                        }
                        ref={txtCiudad}
                        className="form-select form-select-sm"
                        id="inputStatus"
                        name="ciudad"
                        onChange={onChange}
                        value={
                          values.ciudad !== null ? values.ciudad.trim() : ""
                        }
                      >
                        <option value="">Seleccione</option>
                        {ciudades &&
                          ciudades.map((item, index) => (
                            <option key={index} value={item.idciudad}>
                              {" "}
                              {item.nombre}{" "}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className=" col-md-6 row py-3 px-2">
                    <div className="col-sm-11 p-0 text-success2">
                      <h4 className="text-success2  titulos">
                        <i className="fas fa-lg px-2 fa-user-edit"></i>Datos del
                        Representante Legal
                      </h4>
                      <hr />
                    </div>

                    <div className="input-group mx-auto py-1 row input-group-sm col-sm-6">
                      <label
                        className="col-sm-3 input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Cédula:
                      </label>
                      <select
                        ref={cmbNacionalidad}
                        defaultValue={
                          props.expendedor && props.expendedor.nacionalidad
                        }
                        disabled={
                          operacion === 4 || operacion === 3 ? true : false
                        }
                        className="col-sm-3 form-select form-select-sm px-1"
                      >
                        <option key="V" value="V">
                          V
                        </option>
                        <option key="E" value="E">
                          E
                        </option>
                      </select>
                      <input
                        type="text"
                        className="form-control form-control-sm px-1"
                        autoComplete="off"
                        defaultValue={
                          props.expendedor ? props.expendedor.cedula : ""
                        }
                        placeholder="123456789"
                        ref={txtCedula}
                        disabled={
                          operacion === 4 || operacion === 3 ? true : false
                        }
                        maxLength="10"
                        name="cedularespo"
                        onChange={onChange}
                        onKeyUp={validarPersona}
                        onBlur={validarPersona}
                        id="inputCedrespon"
                      />
                      <button
                        className="btn btn-sm col-sm-2  btn-info "
                        disabled={
                          operacion === 4 || operacion === 3 ? true : false
                        }
                        onClick={handleCatalogo}
                      >
                        <i className="fa fa-search"></i>{" "}
                      </button>
                    </div>

                    <div className="col-sm-3"></div>

                    <div className="input-group py-1 input-group-sm col-sm-3">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Sexo:
                      </label>
                      <select
                        disabled={
                          !habilitadoNU || operacion === 4 || operacion === 3
                            ? true
                            : false
                        }
                        defaultValue={props.expendedor && props.expendedor.sexo}
                        ref={cmbSex}
                        className=" form-select form-select-sm"
                        id="inputLetraRif"
                      >
                        <option value="">-</option>
                        <option key="0" value="M">
                          M
                        </option>
                        <option key="1" value="F">
                          F
                        </option>
                      </select>
                    </div>

                    <div className="input-group py-1 input-group-sm col-sm-6">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Nombres:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        defaultValue={
                          props.expendedor ? props.expendedor.nombres : ""
                        }
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        ref={txtNombreRespon}
                        disabled={
                          !habilitadoNU || operacion === 4 || operacion === 3
                            ? true
                            : false
                        }
                        name="nombres"
                        onChange={onChange}
                        id="inputNombrerespon"
                      />
                    </div>
                    <div className="input-group py-1 input-group-sm col-sm-6">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Apellidos:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        disabled={
                          !habilitadoNU || operacion === 4 || operacion === 3
                            ? true
                            : false
                        }
                        defaultValue={
                          props.expendedor ? props.expendedor.apellidos : ""
                        }
                        aria-label="Sizing example input"
                        ref={txtApeRespon}
                        aria-describedby="inputGroup-sizing-sm"
                        name="apellidosp"
                        id="inputApellidos"
                        onChange={onChange}
                      />
                    </div>

                    <div className="input-group py-1 input-group-sm col-sm-12">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Dirección:
                      </label>
                      <textarea
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        aria-label="Sizing example input"
                        defaultValue={
                          props.expendedor ? props.expendedor.direccionresp : ""
                        }
                        aria-describedby="inputGroup-sizing-sm"
                        ref={txtDireccionRespon}
                        disabled={
                          !habilitadoNU || operacion === 4 || operacion === 3
                            ? true
                            : false
                        }
                        name="direccionrespo"
                        onChange={onChange}
                        id="inputDireccionrespon"
                      />
                    </div>

                    <div className="input-group py-1 input-group-sm col-sm-6">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        E-mail:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        disabled={
                          !habilitadoNU || operacion === 4 || operacion === 3
                            ? true
                            : false
                        }
                        aria-label="Sizing example input"
                        ref={txtEmailr}
                        aria-describedby="inputGroup-sizing-sm"
                        defaultValue={
                          props.expendedor ? props.expendedor.correoe : ""
                        }
                        name="correoe"
                        id="inputEmail"
                        onChange={onChange}
                      />
                    </div>
                    <div className="input-group py-1 input-group-sm col-sm-6">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Fecha Nacimiento:
                      </label>
                      <input
                        type="date"
                        autoComplete="off"
                        className="form-control"
                        disabled={
                          !habilitadoNU || operacion === 4 || operacion === 3
                            ? true
                            : false
                        }
                        max={moment(fechas).format("YYYY-MM-DD")}
                        ref={txtFechNac}
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        defaultValue={
                          props.expendedor
                            ? moment(props.expendedor.fnacimiento).format(
                                "YYYY-MM-DD"
                              )
                            : ""
                        }
                        id="inputFnac"
                      />
                    </div>
                    <div className="input-group py-1 input-group-sm col-sm-6">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Teléfono:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        disabled={
                          !habilitadoNU || operacion === 4 || operacion === 3
                            ? true
                            : false
                        }
                        aria-label="Sizing example input"
                        ref={txtTlf1}
                        aria-describedby="inputGroup-sizing-sm"
                        maxLength="12"
                        defaultValue={
                          props.expendedor ? props.expendedor.tlf1 : ""
                        }
                        onChange={handleInputNumChange}
                        id="inputTelefrespon"
                        name="tlf1"
                      />
                    </div>

                    <div className="input-group py-1 input-group-sm col-sm-6">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Celular:
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        disabled={
                          !habilitadoNU || operacion === 4 || operacion === 3
                            ? true
                            : false
                        }
                        aria-label="Sizing example input"
                        ref={txtTlf2}
                        maxLength="12"
                        aria-describedby="inputGroup-sizing-sm"
                        defaultValue={
                          props.expendedor ? props.expendedor.tlf2 : ""
                        }
                        id="inputCel"
                        name="tlf2"
                      />
                    </div>
                  </div>

                  <hr className="col-sm-11 py-0 px-2 mx-auto container text-success2" />

                  <div className="col-md-12 row" style={{ margin: 0 }}>
                    <div className="row" style={{ margin: 0 }}>
                      <div className="col-sm-2">
                        <h4 className="text-success2 titulos">
                          <i className="fas fa-lg px-1 fa-user-edit"></i> Datos
                          Tributarios{" "}
                        </h4>
                      </div>

                      <div className="form-check col-sm-2 form-check-inline">
                        <input
                          className="form-check-input rounded rounded-circle"
                          type="checkbox"
                          id="conveniomina"
                          name="conveniomina"
                          disabled={
                            operacion === 4 || operacion === 3 ? true : false
                          }
                          ref={chkConvenio}
                          onChange={onChange}
                          defaultChecked={
                            props.expendedor &&
                            props.expendedor.conveniomina === true
                              ? true
                              : false
                          }
                        />
                        <label
                          className="form-check-label "
                          htmlFor="flexCheckChecked7"
                        >
                          ¿Convenio?
                        </label>
                      </div>

                      <div className="form-check col-sm-2 form-check-inline">
                        <input
                          className="form-check-input rounded rounded-circle"
                          type="checkbox"
                          id="flexCheckChecked7"
                          name="flexCheckChecked7"
                          disabled={
                            operacion === 4 || operacion === 3 ? true : false
                          }
                          ref={txtDeclara}
                          onChange={onChange}
                          defaultChecked={props.expendedor.declara}
                        />
                        <label
                          className="form-check-label "
                          htmlFor="flexCheckChecked7"
                        >
                          ¿Declara Web?
                        </label>
                      </div>

                      <div className="input-group py-1 input-group-sm col-sm-4">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          MES 1RA DECLARACIÓN:{" "}
                        </label>
                        <select
                          disabled={
                            operacion === 4 || operacion === 3 ? true : false
                          }
                          ref={cmbMesDecla}
                          name="mesprideclamina"
                          onChange={onChange}
                          defaultValue={
                            props.expendedor && props.expendedor.mesprideclamina
                              ? props.expendedor.mesprideclamina
                              : ""
                          }
                          className="col-sm-5 px-2 form-select form-control-sm"
                        >
                          <option value="">-</option>
                          <option key="1" value="1">
                            ENERO
                          </option>
                          <option key="2" value="2">
                            FEBRERO
                          </option>
                          <option key="3" value="3">
                            MARZO
                          </option>
                          <option key="4" value="4">
                            ABRIL
                          </option>
                          <option key="5" value="5">
                            MAYO
                          </option>
                          <option key="6" value="6">
                            JUNIO
                          </option>
                          <option key="7" value="7">
                            JULIO
                          </option>
                          <option key="8" value="8">
                            AGOSTO
                          </option>
                          <option key="9" value="9">
                            SEPTIEMBRE
                          </option>
                          <option key="10" value="10">
                            OCTUBRE
                          </option>
                          <option key="11" value="11">
                            NOVIEMBRE
                          </option>
                          <option key="12" value="12">
                            DICIEMBRE
                          </option>
                        </select>
                      </div>

                      <div className="input-group py-1 input-group-sm col-sm-3">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          AÑO 1RA DECLARACIÓN:{" "}
                        </label>
                        <select
                          disabled={
                            operacion === 4 || operacion === 3 ? true : false
                          }
                          ref={cmbAnioDecla}
                          className="form-select form-select-sm"
                          id="inputStatus"
                          name="anioprideclamina"
                          onChange={onChange}
                          defaultValue={
                            props.expendedor &&
                            props.expendedor.anioprideclamina !== null
                              ? props.expendedor.anioprideclamina
                              : ""
                          }
                        >
                          <option value="">--</option>
                          {anios &&
                            anios.map((item, index) => (
                              <option key={index} value={item}>
                                {" "}
                                {item}{" "}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-8 row py-3">
                      <div className="col-sm-4">
                        <div className="input-group input-group-sm col-sm-12 ">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            Nº de Resolución:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            className="form-control"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                            disabled={
                              operacion === 4 || operacion === 3 ? true : false
                            }
                            ref={txtResolucion}
                            name="nroresolucionmina"
                            defaultValue={
                              props.expendedor
                                ? props.expendedor.nroresolucionmina
                                : ""
                            }
                            onChange={onChange}
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="input-group input-group-sm col-sm-12 ">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            Nº de Licencia:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            className="form-control"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                            disabled={
                              operacion === 4 || operacion === 3 ? true : false
                            }
                            ref={txtLicencia}
                            name="nrolicenciamina"
                            defaultValue={
                              props.expendedor
                                ? props.expendedor.nrolicenciamina
                                : ""
                            }
                            onChange={onChange}
                            id="inputRitm"
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="input-group input-group-sm col-sm-12">
                          <label
                            className="input-group-text"
                            id="inputGroup-sizing-sm"
                          >
                            Crédito Bs:
                          </label>
                          <input
                            type="text"
                            autoComplete="off"
                            className="form-control text-right"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-sm"
                            disabled={
                              operacion === 4 || operacion === 3 ? true : false
                            }
                            maxLength="20"
                            ref={txtMonto}
                            defaultValue={
                              values && values.credito
                                ? formatMoneda(
                                    values.credito
                                      .toString()
                                      .replace(",", "")
                                      .replace(".", ","),
                                    ",",
                                    ".",
                                    2
                                  ).trim()
                                : ""
                            }
                            onBlur={handleInputMontoChange}
                            onKeyUp={handleInputMontoChange}
                            placeholder="0,00"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <fieldset className="col-sm-10 row border rounded">
                        <legend
                          className="float-none w-auto"
                          style={{ fontSize: "15px" }}
                        >
                          Exonerar
                        </legend>

                        <div className="form-check col form-check-inline">
                          <input
                            className="form-check-input rounded rounded-circle"
                            type="checkbox"
                            id="flexCheckChecked0"
                            name="exoninteresesmina"
                            disabled={
                              operacion === 4 || operacion === 3 ? true : false
                            }
                            ref={chkIn}
                            onChange={onChange}
                            defaultChecked={props.expendedor.exoninteresesmina}
                          />
                          <label
                            className="form-check-label "
                            htmlFor="flexCheckChecked0"
                          >
                            Interés
                          </label>
                        </div>

                        <div className="form-check col form-check-inline">
                          <input
                            className="form-check-input rounded rounded-circle"
                            type="checkbox"
                            id="flexCheckChecked1"
                            name="exonmultasmina"
                            disabled={
                              operacion === 4 || operacion === 3 ? true : false
                            }
                            ref={chkIn1}
                            onChange={onChange}
                            defaultChecked={props.expendedor.exonmultasmina}
                          />
                          <label
                            className="form-check-label "
                            htmlFor="flexCheckChecked1"
                          >
                            Multas
                          </label>
                        </div>

                        <div className="form-check col form-check-inline">
                          <input
                            className="form-check-input rounded rounded-circle"
                            type="checkbox"
                            id="flexCheckChecked2"
                            name="exonrecargosmina"
                            disabled={
                              operacion === 4 || operacion === 3 ? true : false
                            }
                            ref={chkIn2}
                            onChange={onChange}
                            defaultChecked={props.expendedor.exonrecargosmina}
                          />
                          <label
                            className="form-check-label "
                            htmlFor="flexCheckChecked2"
                          >
                            Recargos
                          </label>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-12 py-2 d-flex justify-content-end  align-items-center">
                <button
                  ref={btnAcepta}
                  disabled={operacion === 4 ? true : false}
                  onClick={onChangeValidar}
                  className="btn btn-sm rounded-pill btn-success col-md-2"
                >
                  <i className="fas fa-check-circle"> Aceptar</i>
                </button>
                <button
                  ref={btnCancela}
                  onClick={cancelar}
                  className="btn btn-danger btn-sm rounded-pill col-md-2"
                >
                  <i className="fas fa-window-close"> Cancelar</i>
                </button>
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="ex-with-icons-tabs-2"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-2"
            >
              <TablaClaseMinas
                tabclase={tabActividades}
                seleccionarCampos={seleccionarCampos}
                eliminarCampos={eliminarCampos}
                operacion={operacion}
              />
            </div>
            <div
              className="tab-pane fade"
              id="ex-with-icons-tabs-3"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-3"
            >
              <TablaDeudaMinas
                tabdeuda={tabDeuda}
                credito={
                  values
                    ? values.credito !== null
                      ? values.credito
                      : "0,00"
                    : "0,00"
                }
              />
            </div>
            <div
              className="tab-pane fade"
              id="ex-with-icons-tabs-4"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-4"
            >
              <TablaHistoricoMinas tabpago={tabPago} />
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/minas/modalExpMinas.js